// File: frontend/src/components/Contacts/contactFormat.js
// Shared display helpers for contacts (page filters + list items).

// lead_score está en escala 0-10. Escala y bandas: frontend/src/utils/leadScore.js.
export { getScoreColor, getScoreTextColor, formatLeadScore } from '../../utils/leadScore';

export const getLifecycleColor = (stage) => {
  const colorMap = {
    subscriber: 'bg-gray-100 text-gray-800',
    lead: 'bg-blue-100 text-blue-800',
    marketing_qualified_lead: 'bg-yellow-100 text-yellow-800',
    sales_qualified_lead: 'bg-orange-100 text-orange-800',
    opportunity: 'bg-purple-100 text-purple-800',
    customer: 'bg-green-100 text-green-800',
    evangelist: 'bg-pink-100 text-pink-800',
  };
  return colorMap[stage] || 'bg-gray-100 text-gray-800';
};

export const getStatusColor = (status) => {
  const colorMap = {
    New: 'bg-blue-100 text-blue-800',
    Contacted: 'bg-yellow-100 text-yellow-800',
    Qualified: 'bg-green-100 text-green-800',
    'Meeting Scheduled': 'bg-purple-100 text-purple-800',
    'Proposal Sent': 'bg-orange-100 text-orange-800',
    'Closed Won': 'bg-green-100 text-green-800',
    'Closed Lost': 'bg-red-100 text-red-800',
  };
  return colorMap[status] || 'bg-gray-100 text-gray-800';
};

export const formatLifecycleStage = (stage) => {
  const formatMap = {
    subscriber: 'Assinante',
    lead: 'Lead',
    marketing_qualified_lead: 'MQL',
    sales_qualified_lead: 'SQL',
    opportunity: 'Oportunidade',
    customer: 'Cliente',
    evangelist: 'Evangelista',
  };
  return formatMap[stage] || stage;
};

export const formatStatus = (status) => {
  const formatMap = {
    new: 'Novo',
    contacted: 'Contatado',
    qualified: 'Qualificado',
    unqualified: 'Desqualificado',
    follow_up: 'Follow-up',
    meeting_scheduled: 'Reunião Agendada',
    proposal_sent: 'Proposta Enviada',
    negotiation: 'Negociação',
    closed_won: 'Fechou Ganho',
    closed_lost: 'Fechou Perdido',
  };
  return formatMap[status] || status;
};
